var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eb-page',[_c('eb-navbar',{attrs:{"large":"","largeTransparent":"","title":_vm.$text('CMS'),"eb-back-link":"Back"}}),_vm._v(" "),(_vm.ready)?_c('f7-list',_vm._l((_vm.items),function(item){return _c('eb-list-item',{key:item.key,attrs:{"title":item.title,"link":"#","eb-href":`/a/cms/config/list?module=${item.moduleName}&atomClassName=${
        item.atomClassName
      }&title=${encodeURIComponent(item.title)}`}})}),1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }